module.exports = __webpack_public_path__ + "static/media/downArrow.e710b743.svg";